import { create } from "zustand";
import { persist } from "zustand/middleware";

interface ProjectState {
  /** Selected project id. `null` means "All" (team-wide). */
  selectedProjectId: string | null;
  setSelectedProject: (id: string | null) => void;
}

export const useProjectStore = create<ProjectState>()(
  persist(
    (set) => ({
      selectedProjectId: null,
      setSelectedProject: (id) => set({ selectedProjectId: id }),
    }),
    { name: "project-storage" }
  )
);
